(function () {
  let barLinks = document.querySelectorAll('.progressbar__item > a');

  barLinks.forEach(function (link) {
    link.addEventListener('click', function (event) {
      const redirectUrl = document.querySelector(
        'input[type="hidden"][name="submit_redirect"]'
      );
      if (redirectUrl) {
        //update the value to this link
        redirectUrl.value = link.href;
      }
      const modal = document.querySelector('.accessible-modal-breadcrumbs');

      if (modal) {
        event.preventDefault();
      }

      //check if switching toolkit and update the content
      const cap_toolkit = document.querySelector(
        'input[type="hidden"][name="cap_toolkit"]'
      );
      const new_toolkit = document.querySelector(
        'input[type="radio"][name="original_toolkit"]:checked'
      );

      if (cap_toolkit && new_toolkit && modal) {
        if (cap_toolkit.value != new_toolkit.value) {
          if (modal) {
            const h4 = modal.querySelector('.heading-save');
            h4.textContent = 'Switching Toolkits?';
            const content = modal.querySelector('.accessible-modal__content');
            content.innerHTML =
              "<p>Switching Toolkits will clear any content added to the 'Steps' and 'Evaluation' sections. These sections will update with the new Toolkit's content to fill in. </p><p>Click " +
              '"Update Toolkit"' +
              ' to continue with selecting a new Toolkit, or ' +
              '"Cancel"' +
              ' to go back to.</p>';

            const discardBtn = modal.querySelector(
              '.js-accessible-modal-discard'
            );
            discardBtn.textContent = 'Cancel';

            const discardBtn2 = modal.querySelector('.btn-primary');
            discardBtn2.textContent = 'Update Toolkit';
          }
        }
      }
    });
  });
})();
